
define(
	'Tavano.TavanoteamGA4.TTGA4.MyAccount'
,   [
        'Tavano.TavanoteamGA4.TTGA4.Utils'
    ,   'AjaxRequestsKiller'

    ,   'Backbone'
	]
,   function (
        TTGA4Utils
    ,   AjaxRequestsKiller

    ,   Backbone
	)
{
	'use strict';

	return  {
		loadGA4MyAccount: function loadGA4MyAccount (container)
		{
            this.trackPageGA4(container);

            var self = this;

            this.app = TTGA4Utils.getApplication('MyAccount');

            container.getLayout().on('afterAppendView', function()
            {
                var curView = container.getLayout().getCurrentView()
                ,   timeout = null
                ,   itemsSearcher = container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') ? container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') : {};

                    //to ensure that previous events listeners are removed
                    //this is to avoid multiple triggers of the same event
                    //Start
                    if(Object.keys(itemsSearcher).length > 0)
                    {
                        itemsSearcher.$searchElement.off('keyup')
                        itemsSearcher.$searchElement.on('keyup', function(event)
                        {
                            var searchQuery = jQuery(event.currentTarget).val();
    
                            clearTimeout(timeout);
    
                            timeout = setTimeout(function()
                            {
                                if(searchQuery.trim().length >= itemsSearcher.options.minLength)
                                {
                                    var resultCollection = itemsSearcher.collection
                                    ,   sort = itemsSearcher.options.sort
                                    ,   limit = itemsSearcher.options.limit
                                    ,   ajaxKiller = AjaxRequestsKiller.AjaxRequestsKiller ? AjaxRequestsKiller.AjaxRequestsKiller : AjaxRequestsKiller;
    
                                    resultCollection.fetch({
                                        data: {
                                            q: String(searchQuery).trim()
                                        ,   sort: sort
                                        ,   limit: limit
                                        ,   offset: 0
                                        }
                                    ,   killerId: ajaxKiller.getKillerId()
                                    },
                                    {
                                        silent: true
                                    })
                                    .done(function(searchResult)
                                    {
                                        if(searchResult.items.length > 0)
                                        {
                                            console.log("here")
                                            TTGA4Utils.trackSearchGA4(searchQuery.trim(), 'Search Suggestion', self.app);
                                        }
                                    })
                                }
                            }, 500)
                        });
                    }
                    //end

                if(curView.currentStep && curView.currentStep.step_url == "request-a-quote-confirmation")
                {
                    self.trackGenerateLead(container);
                }
            })
		}
    ,   trackPageGA4: function(container)
        {
            // if(TTGA4Utils.isBundleMinVersion())
            // {
            //     TTGA4Utils.trackPageViewGA4(curUrl, container);
            // }
            // else
            // {
                container.getLayout().on('beforeAppendView', function()
                {
                    var curUrl = Backbone.history.fragment ? '/'+Backbone.history.fragment : '/';

                    TTGA4Utils.trackPageViewGA4(curUrl, container);
                })
            // }
        }

    ,   trackGenerateLead: function(container)
        {
            var self = this
            ,   model = container.getLayout().getCurrentView().wizard.model
            ,   quoteId = model.get('confirmation').get('tranid') || model.get('confirmation').get('confirmationnumber') || '';

            if(model)
            {
                var eventData = this.getQuoteItems(model);

                eventData['quote_id'] = quoteId;

                TTGA4Utils.trackGenerateLead(eventData, container);
            }
        }
    ,   getQuoteItems: function(model)
        {
            if(Object.keys(model).length > 0)
            {
                var quoteItemsObj = {}
                ,   quoteItemsArr = []
                ,   lines = model.get('lines') || []
                ,   quoteSummary = model.get('summary') || {}
                ,   self = this;
    
                _.each(lines.models, function(line)
                {
                    var itemVariant = self.getItemOptions(line)
                    ,   itemObj = {
                        item_id: line.get('item').get('itemid')
                    ,   item_name: line.get('item').get('displayname')
                    ,   quantity: line.get('quantity')
                    ,   price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                    };

                    if(itemVariant.length > 0)
                    {
                        itemObj['item_variant'] = itemVariant.join(',')
                    }

                    quoteItemsArr.push(itemObj);
                });
                quoteItemsObj.currency = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                quoteItemsObj.value = quoteSummary.total;
                quoteItemsObj.items = quoteItemsArr;
    
                return quoteItemsObj;
            }
        }
    ,   getItemOptions: function(item)
        {
            var variantsArr = []
            ,   itemOptions = item.get('options') || []
            ,   itemOptionsModel = itemOptions.models || [];

            _.each(itemOptionsModel, function(option)
            {
                var optionsValue = option.get('value') || {};

                variantsArr.push(optionsValue.label);
            });

            return variantsArr;
        }
	};
});
